import { render, staticRenderFns } from "./TabQuote.vue?vue&type=template&id=20547fae&"
import script from "./TabQuote.vue?vue&type=script&lang=js&"
export * from "./TabQuote.vue?vue&type=script&lang=js&"
import style0 from "./TabQuote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports